import axios from 'axios';

const HOSTAPI = process.env.REACT_APP_BASE_URL;

const MeetingFull = async (payload: { email: string }, eventId: string) => {
  try {
    const response = await axios.put(`${HOSTAPI}/events/${eventId}/update-webinar-status`, payload, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return {
      status: response.status,
      data: response.data,
    };
  } catch (error: any) {
    return {
      status: error.response?.status,
      data: error.response?.data,
    };
  }
};

export default MeetingFull;
